import React from 'react'

import { useTranslation } from 'react-i18next'

import CopyToSiteDialog from '@components/myScores/ControlArea/CopyToSiteDialog'
import Button from '@components/shared/Button'
import { useSelection } from '@providers/SelectionProvider'
import { useDialogStore } from '@stores/dialog.store'
import { useSession } from '@stores/globalData/globalData.store'

const CopyToSiteButton: React.FC = () => {
  const { t } = useTranslation()

  const openDialog = useDialogStore((s) => s.openDialog)
  const session = useSession()
  const { selectedItems } = useSelection()

  if (!session.current_user?.sites_enabled) {
    return null
  }
  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="font-medium ml-2.5"
        onClick={() => openDialog('copy_to_site')}
        disabled={!selectedItems.length}>
        {t('action.copyToSite')}
      </Button>
      <CopyToSiteDialog />
    </>
  )
}

export default CopyToSiteButton
